import React, { useEffect, useState } from 'react';
import { Button, Table, Input, Tooltip, Breadcrumb, Avatar } from 'antd';
import { toast } from 'react-toastify';
import { HomeOutlined } from '@ant-design/icons';
import { fetchVentes, updateVenteEtat } from '../../../../services/ventes/ventesApi'; // Add the update function
import BackupCodesModal from './modals/BackupCodesModal';
import EtatModal from './modals/EtatModal'; // Import the new modal
import { formateCoins } from '../../../../function';
import ImageModal from '../../../../components/imageModal';

const Ventes = () => {
    const [ventes, setVentes] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage] = useState(10);
    const [loading, setLoading] = useState(true);
    const [backupCodesModalOpen, setBackupCodesModalOpen] = useState(false);
    const [etatModalOpen, setEtatModalOpen] = useState(false); // New state for etat modal
    const [imageModalOpen, setImageModalOpen] = useState(false);
    const [image, setImage] = useState(null);
    const [backupCodes, setBackupCodes] = useState([]);
    const [selectedVente, setSelectedVente] = useState(null); // Store selected vente for editing
    const url_media = process.env.REACT_APP_MEDIA_URL||"https://api.masterfut.com/public/storage";

    const showBackupCodes = (backupCodes) => {
        setBackupCodes(backupCodes);
        setBackupCodesModalOpen(true);
    };

    const showImage = (imageUrl) => {
        setImage(imageUrl);
        setImageModalOpen(true);
    };

    const showEtatModal = (vente) => {
        setSelectedVente(vente);
        setEtatModalOpen(true);
    };

    const handleEtatChange = async (venteId, newEtat) => {
        try {
          await updateVenteEtat(venteId, newEtat); // now newEtat = { etat: 'paye' }
          loadVentes();
          toast.success('État mis à jour avec succès');
        } catch (error) {
          toast.error("Erreur lors de la mise à jour de l'état");
          throw error;
        }
      };
      

    useEffect(() => {
        loadVentes();
    }, [search, currentPage]);

    const loadVentes = () => {
        fetchVentes(search, perPage, currentPage)
            .then((response) => {
                setVentes(response.data.ventes);
                setTotalRows(response.data.totalRows);
                setLoading(false);
            })
            .catch((error) => {
                toast.error('Error fetching ventes.');
                setLoading(false);
            });
    };

const columns = [
    {
        title: 'Vendeur',
        dataIndex: 'vendeur',
        key: 'vendeur',
        render: (text, record) => (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Avatar
                    src={record.user.photo_profil ? `${record.user.photo_profil}` : undefined}
                    style={{
                        background: record.user.photo_profil ? undefined : "var(--primary-color) !important",
                        color: 'white',
                    }}
                >
                    <h5 style={{ marginTop: 1 }}>{record.user.photo_profil ? null : record.user.username.charAt(0).toUpperCase()}</h5>
                </Avatar>
                <div>
                    <p style={{ marginLeft: 8 }}>{record.user.username}</p>
                    <p style={{ marginLeft: 8 }}>{record.user.email}</p>
                </div>
            </div>
        ),
    },
    {
        title: 'Date de Vente',
        dataIndex: 'date_vente',
        key: 'date_vente',
        minWidth: 200,
        align:'center',
    },
    {
        title: 'État',
        dataIndex: 'etat',
        key: 'etat',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <span style={{ 
                    padding: '4px 8px', 
                    borderRadius: '4px',
                    backgroundColor: 
                        record.etat === 'paye' ? '#d4edda' : 
                        record.etat === 'annule' ? '#f8d7da' : '#fff3cd',
                    color: 
                        record.etat === 'paye' ? '#155724' : 
                        record.etat === 'annule' ? '#721c24' : '#856404',
                    border: '1px solid',
                    borderColor: 
                        record.etat === 'paye' ? '#c3e6cb' : 
                        record.etat === 'annule' ? '#f5c6cb' : '#ffeaa7'
                }}>
                    {record.etat === 'paye' ? 'Payé' : 
                     record.etat === 'annule' ? 'Annulé' : 'En attente'}
                </span>
                <Tooltip title="Modifier l'état">
                    <Button 
                        type="default" 
                        size="small" 
                        onClick={() => showEtatModal(record)}
                    >
                        <i className="bi bi-pencil" />
                    </Button>
                </Tooltip>
            </div>
        ),
    },
    {
        title: 'Login',
        dataIndex: 'login',
        key: 'login',
        minWidth: 200,
        align:'center',
    },
    {
        title: 'Password',
        dataIndex: 'password',
        key: 'password',
        minWidth: 200,
        align:'center',
    },
    {
        title: 'Backup Codes',
        dataIndex: 'backup_codes',
        key: 'backup_codes',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <Tooltip title="Voir les codes">
                <Button type='primary' className='border border-primary' shape='circle' onClick={() => showBackupCodes(record.backups)}>
                    <i className="bi bi-eye" />
                </Button>
            </Tooltip>
        ),
    },
    {
        title: 'Montant',
        dataIndex: 'montant',
        key: 'montant',
        minWidth: 200,
        align:'center',
        render: (text, record) => {
            const formattedAmount = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(record.montant || 0);
            
            return (
                <div>
                    <p>{formattedAmount} USD</p>
                </div>
            );
        },
    },
    {
        title: 'Coins',
        dataIndex: 'coins',
        key: 'coins',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div>
                <p>{formateCoins(record.coins)}</p>
            </div>
        ),
    },
    {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        minWidth: 200,
        align:'center',
    },
    {
        title: 'Total Reglements',
        dataIndex: 'total_reglements',
        key: 'total_reglements',
        minWidth: 200,
        align:'center',
        render: (text, record) => {
            const formattedAmount = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(record.total_reglements || 0);
            
            return (
                <div>
                    <p>{formattedAmount}</p>
                </div>
            );
        },
    },
    {
        title: 'Coin Restant',
        dataIndex: 'reste_montant',
        key: 'reste_montant',
        minWidth: 200,
        align:'center',
        render: (text, record) => {
            const formattedAmount = new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(record.reste_montant || 0);
            
            return (
                <div>
                    <p>{formattedAmount}</p>
                </div>
            );
        },
    },
    {
        title: 'Compte',
        dataIndex: 'compte',
        key: 'compte',
        minWidth: 200,
        align:'center',
    },
    {
        title: 'Methode',
        dataIndex: 'methode',
        key: 'methode',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div>
                <p>{record.methode.nom}</p>
            </div>
        ),
    },
    {
        title: 'Network',
        dataIndex: 'network',
        key: 'network',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div>
                <p>{record.network}</p>
            </div>
        ),
    },
    {
        title: 'Nom',
        dataIndex: 'nom',
        key: 'nom',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div>
                <p>{record.nom}</p>
            </div>
        ),
    },
    {
        title: 'Prenom',
        dataIndex: 'prenom',
        key: 'prenom',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div>
                <p>{record.prenom}</p>
            </div>
        ),
    },
    {
        title: 'Whatsapp',
        dataIndex: 'whatsapp',
        key: 'whatsapp',
        render: (text, record) => (
            <p>{record.user.whatssap}</p>
        ),
    },
    {
        title: 'Image',
        dataIndex: 'image',
        key: 'image',
        minWidth: 200,
        align:'center',
        render: (text, record) => (
            <div>
                <Button type='primary' className='border border-primary' shape='circle' onClick={() => showImage(record.image.image)}>
                    <i className="bi bi-eye" />
                </Button>
            </div>
        ),
    }
];

    return (
        <>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 className='col-lg-11'>
                        <div className="mb-2">
                            <i className="bx bx-tag me-2" style={{color:"var(--primary-color3) !important"}}/>
                            <h3 style={{color:"var(--primary-color3) !important"}}>Ventes</h3>
                        </div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <HomeOutlined />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item style={{color:"var(--primary-color3) !important"}}>Ventes</Breadcrumb.Item>
                        </Breadcrumb>
                    </h4>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
                    <Input
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Rechercher"
                        value={search}
                        suffix={<i className="bi bi-search" />}
                        style={{ width: '200px' }}
                    />
                </div>
                <Table
                    dataSource={ventes}
                    columns={columns}
                    pagination={{ current: currentPage, total: totalRows, pageSize: perPage, onChange: setCurrentPage }}
                    scroll={{ x: 1000 }}
                    loading={loading}
                />
                <BackupCodesModal
                    isOpen={backupCodesModalOpen}
                    onClose={() => setBackupCodesModalOpen(false)}
                    backupCodes={backupCodes}
                />
                <EtatModal
                    isOpen={etatModalOpen}
                    onClose={() => setEtatModalOpen(false)}
                    vente={selectedVente}
                    onEtatChange={handleEtatChange}
                />
                <ImageModal
                    open={imageModalOpen}
                    onClose={() => setImageModalOpen(false)}
                    imageUrl={image}
                />
            </div>
        </>
    );
};

export default Ventes;